import React, { useRef } from 'react'
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import { Loader } from 'rsuite';
import { BsCheckSquare, BsXSquare } from 'react-icons/bs'

const BasicInfo = ({ basicInfo, selectedBasicInfo, columns, selectedSuppliers, onChangeBasicInfo, childBasicInfo, isPhoneValid, isValidatingPhone, handleBasicInfoPhoneNumberFocusOut, handleBasicInfoEmailFocusOut, isEmailValid, isEmailRisky, isValidatingEmail, countryCode, onFieldClick }) => {
    const handleChange = (
        columnName,
        newValue,
        country,
        event
    ) => {

        if (columnName === 'phone') {
            onChangeBasicInfo(columnName, newValue, country, event)
        } else {
            onChangeBasicInfo(columnName, newValue)
        }
    }
    const phoneInputRefname = useRef(null);

    const handleKeyDown = (e, phoneInputRefname) => {
        if (e.keyCode === 9) {
            phoneInputRefname.current.props.onBlur()
        }
    }

    const handleEmailFocusOut = async (emailValue) => {
        handleBasicInfoEmailFocusOut(emailValue)
    }
    const supplier_types = ['related', 'master'];

    return (
        <div className="basic-tab">
            <div className="main-info">
                {
                    columns && columns.length > 0 && columns.map(col => {
                        if (col.name === 'url' || col.name === 'naics' || col.name === 'sic' || col.name === 'state') {
                            return
                        }
                        return (<div key={col.name} className='main-info-child flex'>
                            <h4 className='first-child fw-bold text-black mb-0'>{col.label}:</h4>
                            {col.name === 'phone' ?
                                <>
                                    <div className="phone-input-parent flex align-center">
                                        <div className='d-flex border rounded border-dark phone-input-ext-container w-100 flex-column flex-lg-row'>
                                            <ReactPhoneInput
                                                className='phone-input-parent'
                                                country={'us'}
                                                value={basicInfo?.[col.name] || ''}
                                                countryCodeEditable={false}
                                                preferredCountries={['us']}
                                                ref={phoneInputRefname}
                                                buttonClass='border-0 border-end border-dark'
                                                inputProps={{
                                                    className: 'form-control border-0',
                                                    readOnly: true
                                                }}
                                                onClick={() => { onFieldClick(col.name, basicInfo?.[col.name]) }}
                                            />
                                            <div className="input-group phone-extension-container mb-0 flex-nowrap">
                                                <span className="h4 mb-0 d-flex text-dark align-items-center border-0 border-start border-dark rounded-0 bg-white" id="phone_ext">Ext.</span>
                                                <input
                                                    type="text"
                                                    className="shadow-none w-100 border-0 ps-3 pe-3 h4 mb-0 text-dark"
                                                    placeholder="phone extension"
                                                    value={basicInfo?.['phoneExtension'] || ''}
                                                    onClick={() => { onFieldClick(col.name, basicInfo?.['phoneExtension']) }}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="phone-input-parent flex align-center">
                                        <div className='d-flex border rounded border-dark phone-input-ext-container w-100 flex-column flex-lg-row'>
                                            <ReactPhoneInput
                                                className='phone-input-parent'
                                                country={'us'}
                                                value={selectedBasicInfo?.[col.name] || ''}
                                                onChange={(value, country, e, formattedValue) => { handleChange(col.name, formattedValue, country, e) }}
                                                onBlur={(event, country) => { handleBasicInfoPhoneNumberFocusOut(event, country, selectedBasicInfo?.[col.name] || '', col.name) }}
                                                buttonClass='border-0 border-end border-dark'
                                                inputProps={{
                                                    className: 'form-control border-0'
                                                }}
                                            />
                                            <div className="input-group phone-extension-container mb-0 flex-nowrap">
                                                <span className="h4 mb-0 d-flex text-dark align-items-center border-0 border-start border-dark rounded-0 bg-white" id="phone_ext">Ext.</span>
                                                <input type="text" className="shadow-none w-100 border-0 ps-3 pe-3 h4 mb-0 text-dark" placeholder="phone extension"
                                                    value={selectedBasicInfo?.['phoneExtension']}
                                                    onChange={(newValue) => handleChange('phoneExtension', newValue)}
                                                />
                                            </div>
                                        </div>
                                        {isValidatingPhone && (<Loader />)}
                                        {selectedBasicInfo?.[col.name] && !isValidatingPhone && isPhoneValid !== '' &&
                                            (isPhoneValid ?
                                                <BsCheckSquare color="#067911" size={26} />
                                                :
                                                <BsXSquare color="#f75a52" size={26} />
                                            )
                                        }
                                    </div>
                                </>
                                :
                                col.name === 'email' ?
                                    <>
                                        <div className="phone-input-parent flex align-center">
                                            <input
                                                type="text"
                                                className="search-input h4 mb-0"
                                                value={basicInfo?.[col.name] || ''}
                                                onClick={() => { onFieldClick(col.name, basicInfo?.[col.name]) }}
                                                readOnly={true}
                                            />
                                        </div>
                                        <div className="phone-input-parent flex align-center">
                                            <input
                                                type="text"
                                                className="search-input h4 mb-0"
                                                value={selectedBasicInfo?.[col.name] || ''}
                                                onChange={(newValue) => { handleChange(col.name, newValue) }}
                                                onBlur={() => { handleEmailFocusOut(selectedBasicInfo?.[col.name] || '', 'basic') }}
                                            />
                                            {isValidatingEmail && (<Loader />)}
                                            {selectedBasicInfo?.[col.name] && !isValidatingEmail && isEmailValid !== '' &&
                                                (isEmailRisky ?
                                                    <BsCheckSquare color="#EFD700" size={26} />
                                                    :
                                                    isEmailValid ?
                                                        <BsCheckSquare color="#067911" size={26} />
                                                        :
                                                        <BsXSquare color="#f75a52" size={26} />
                                                )
                                            }
                                        </div>
                                    </>
                                    :
                                    <>
                                        <input
                                            type="text"
                                            className="search-input h4 mb-0"
                                            value={basicInfo?.[col.name] || ''}
                                            onClick={() => { onFieldClick(col.name, basicInfo?.[col.name]) }}
                                            readOnly
                                        />
                                        <input
                                            type="text"
                                            className="search-input h4 mb-0"
                                            value={selectedBasicInfo?.[col.name] || ''}
                                            onChange={(newValue) => { handleChange(col.name, newValue) }}
                                        />
                                    </>
                            }
                        </div>)
                    })
                }
            </div>
            <div className="other">
                <div className="row">
                    <div className="item full">
                        <h4 className='first-child fw-bold text-black mb-0'>URL:</h4>
                        <input
                            type="text"
                            className="search-input h4 mb-0"
                            readOnly
                            value={basicInfo?.['url'] || ''}
                            onClick={() => { onFieldClick('url', basicInfo?.['url']) }}
                        />
                        <input
                            type="text"
                            className="search-input h4 mb-0"
                            value={selectedBasicInfo?.['url'] || ''}
                            onChange={(newValue) => { handleChange('url', newValue) }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="item full">
                        <h4 className='first-child fw-bold text-black mb-0'>NAICS Code:</h4>
                        <input
                            type="text"
                            className="search-input h4 mb-0"
                            readOnly
                            value={basicInfo?.['naics'] || ''}
                            onClick={() => { onFieldClick('naics', basicInfo?.['naics']) }}
                        />
                        <input
                            type="text"
                            className="search-input h4 mb-0"
                            value={selectedBasicInfo?.['naics'] || ''}
                            onChange={(newValue) => { handleChange('naics', newValue) }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="item full">
                        <h4 className='first-child fw-bold text-black mb-0'>SIC Code:</h4>
                        <input
                            type="text"
                            className="search-input h4 mb-0"
                            readOnly
                            value={basicInfo?.['sic'] || ''}
                            onClick={() => { onFieldClick('sic', basicInfo?.['sic']) }}
                        />
                        <input
                            type="text"
                            className="search-input h4 mb-0"
                            value={selectedBasicInfo?.['sic'] || ''}
                            onChange={(newValue) => { handleChange('sic', newValue) }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BasicInfo